import script from "./LayoutHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutHeader.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutHeader.vue?vue&type=style&index=0&id=bf0300d0&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf0300d0"]])

export default __exports__